class BlogSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"].blog__search__input');
    this.panel = this.querySelector('#blog__search__panel')

    this.input.addEventListener('focus', (event) => {this.onFocus(event)})
    this.input.addEventListener('focusout', (event) => {this.onFocusOut(event)})

    // ON INPUT VALUE CHANGE
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim()
    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=article&resources[limit]=4&section_id=blog-predictive-search`)
      .then((response) => {
        if (!response.ok) {
          let error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        this.panel.innerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-blog-predictive-search').innerHTML
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  onFocus() {
    const searchTerm = this.input.value.trim()
    if (searchTerm.length) {
      this.open();
    }
  }

  onFocusOut() {
    document.addEventListener('click', (event) => {
      // let isClickInside = this.panel.contains(event.target)
      let isClickInside = this.contains(event.target)

      if (!isClickInside) {
        this.close()
      }
    })
  }

  open() {
    this.panel.setAttribute('open', true)
    this.input.classList.add("active")
    this.querySelector('button[type="button"].blog__close__button').addEventListener('click', this.close.bind(this))
  }

  close() {
    this.panel.removeAttribute('open')
    this.input.classList.remove("active")
  }

  //CLICK OUTSIDE
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('blog-search', BlogSearch)
